import resolve from "ioc/resolve";
import Media from "webutils/media/media";
import ServiceBus from "servicestack/service-bus";

export default class ProductTemplate {
  constructor(dto) {
    let m = this;
    //m.bus = new ServiceBus();
    //properties
    m.status = "constructing";
    m.height = 0;
    m.width = 0;
    m.id = null; //int
    m.euid = null; //'guid'
    m.images = [];
    m.documents = [];
    m.areas = [];
    Object.assign(m, dto);

    m.images = m.images.map((m) => new Media(m));
    m.documents = m.documents.map((m) => new Media(m));
    m.areas.forEach((a) =>
      a.overlays
        .concat(a.underlays)
        .forEach((o) => (o.media = new Media(o.media)))
    );
  }

  load() {}

  save() {}

  img(size) {
    if (this.images && this.images.length)
      return (this.imageUrl = this.images[0].img(size));
    for (var i in this.areas) {
      var area = this.areas[i];
      for (var j in area.overlays.concat(area.underlays)) {
        var overlay = area.overlays[j];
        if (overlay.isProductImage && overlay.media && overlay.media.url) {
          return (this.imageUrl = overlay.media.img(size));
        }
      }
    }
    return "https://dummyimage.com/250x150/fff/333&fontsize=20&text=Not%20Found...";
  }
}
